module.exports = __webpack_public_path__ + "static/media/web2.df597068.png";